'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const SvgNonVeg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 20, viewBox: "0 0 20 20", fill: "none" }, props),
    React__namespace.createElement("rect", { x: 1, y: 1, width: 18, height: 18, rx: 5, fill: "white" }),
    React__namespace.createElement("g", { clipPath: "url(#NonVeg20_svg__clip0_15100_43820)" },
        React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.74682 18.0825C5.96468 18.2463 7.59351 18.25 10 18.25C12.4065 18.25 14.0353 18.2463 15.2532 18.0825C16.4207 17.9256 16.9452 17.651 17.2981 17.2981C17.651 16.9452 17.9256 16.4207 18.0825 15.2532C18.2463 14.0353 18.25 12.4065 18.25 10C18.25 7.5935 18.2463 5.96468 18.0825 4.74682C17.9256 3.57931 17.651 3.05479 17.2981 2.7019C16.9452 2.34902 16.4207 2.07442 15.2532 1.91745C14.0353 1.75372 12.4065 1.75 10 1.75C7.59351 1.75 5.96468 1.75372 4.74682 1.91745C3.57931 2.07442 3.05479 2.34902 2.7019 2.7019C2.34902 3.05479 2.07442 3.57931 1.91745 4.74682C1.75372 5.96468 1.75 7.59351 1.75 10C1.75 12.4065 1.75372 14.0353 1.91745 15.2532C2.07442 16.4207 2.34902 16.9452 2.7019 17.2981C3.05479 17.651 3.57931 17.9256 4.74682 18.0825ZM1.46447 1.46447C0 2.92893 0 5.28596 0 10C0 14.714 0 17.0711 1.46447 18.5355C2.92893 20 5.28596 20 10 20C14.714 20 17.0711 20 18.5355 18.5355C20 17.0711 20 14.714 20 10C20 5.28596 20 2.92893 18.5355 1.46447C17.0711 0 14.714 0 10 0C5.28596 0 2.92893 0 1.46447 1.46447ZM4.17992 14.0982C4.41822 14.526 5.08017 14.526 6.40406 14.526L13.5959 14.526C14.9198 14.526 15.5818 14.526 15.8201 14.0982C16.0584 13.6704 15.7099 13.1076 15.013 11.982L11.417 6.17428C10.7818 5.14832 10.4642 4.63533 9.99999 4.63533C9.53583 4.63533 9.2182 5.14831 8.58296 6.17428L4.98702 11.982L4.98702 11.982C4.29009 13.1076 3.94162 13.6704 4.17992 14.0982Z", fill: "#E43B4F" })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "NonVeg20_svg__clip0_15100_43820" },
            React__namespace.createElement("rect", { width: 20, height: 20, fill: "white", transform: "matrix(-1 0 0 -1 20 20)" })))));

exports.default = SvgNonVeg20;
//# sourceMappingURL=NonVeg20.js.map
